module.exports = __webpack_public_path__ + "assets/img/18.cf51470b.png";